export class FiltrosDocumentosNegociables{

   Tipo_Comprobante : string ='';
   Id : string ='';
   IdAdq : string ='';
   Estado : string ='R';
   Tipo_Emision : string ='0';
   Adjunto : string ='';
   Numero : string =''; 
   CodOperacion : string =''; 
   user_id:string='';

}
